import { subscribeAppStore } from '@/store';

import getCreditsBalance from './getCreditsBalance';

/**
 * Delivers the balance once it is known — at once if it already is, otherwise
 * on the store update that brings it. Returns the unsubscribe.
 */
const watchCreditsBalance = (
  onReady: (balance: number) => void
): (() => void) => {
  const balance = getCreditsBalance();
  if (balance !== null) {
    onReady(balance);
    return () => {};
  }

  const unsubscribe = subscribeAppStore(() => {
    const next = getCreditsBalance();
    if (next === null) return;
    unsubscribe();
    onReady(next);
  });
  return unsubscribe;
};

export default watchCreditsBalance;
